import React from "react";

export default function StarIcon() {
  return (
    <svg
      className="hover:text-darkblue"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
    >
      <path
        d="M11.7751 2.375L12.0001 2.225L12.2251 2.375L12.4126 2.0375L13.2751 1.5875L12.7501 0.6125C12.6001 0.3125 12.3001 0.125 12.0001 0.125C11.7001 0.125 11.4001 0.3125 11.2501 0.575L10.7251 1.55L11.5876 2L11.7751 2.375Z"
        fill="#637381"
      />
      <path d="M14.0765 3.13843L12.5669 3.89258L13.7232 6.20736L15.2329 5.45321L14.0765 3.13843Z" fill="currentColor" />
      <path
        d="M14.6252 7.96172C14.7377 8.22422 15.0002 8.37422 15.2627 8.41172L16.3877 8.56172L16.6127 6.87422L15.9377 6.79922L15.6377 6.19922L14.1377 6.98672L14.6252 7.96172Z"
        fill="#637381"
      />
      <path d="M18.3676 7.14544L18.1318 8.81641L20.7682 9.18836L21.004 7.5174L18.3676 7.14544Z" fill="currentColor" />
      <path
        d="M23.6628 8.4125C23.5503 8.1125 23.2878 7.8875 22.9878 7.8125L21.8628 7.625L21.7503 8.5625L21.4878 8.7875L21.6753 8.975L21.6378 9.275L22.0128 9.35L22.6503 10.025L23.4753 9.275C23.7003 9.05 23.7753 8.7125 23.6628 8.4125Z"
        fill="currentColor"
      />
      <path d="M20.2254 10.0004L18.3428 11.7754L19.5004 13.0032L21.3831 11.2282L20.2254 10.0004Z" fill="#111928" />
      <path
        d="M18.3377 14.0742L18.8252 13.5867L17.6627 12.3867L16.8752 13.1742C16.6877 13.3617 16.5752 13.6617 16.6127 13.9242L16.8002 15.0117L18.4502 14.7492L18.3377 14.0742Z"
        fill="#111928"
      />
      <path d="M18.7715 16.4185L17.1113 16.7207L17.5747 19.2663L19.2349 18.9641L18.7715 16.4185Z" fill="currentColor" />
      <path
        d="M19.3501 19.7758L18.4501 19.9258L18.0751 19.7383L17.9251 20.0383L17.6626 20.0758L17.7376 20.3758L17.2876 21.2383L18.3001 21.7633C18.4126 21.8383 18.5626 21.8383 18.6751 21.8383C18.8626 21.8383 19.0501 21.7633 19.1626 21.6883C19.4251 21.5008 19.5376 21.1633 19.5001 20.8633L19.3501 19.7758Z"
        fill="currentColor"
      />
      <path d="M14.1897 17.7531L13.4219 19.2559L15.7594 20.4502L16.5273 18.9475L14.1897 17.7531Z" fill="#111928" />
      <path
        d="M11.6253 16.85L10.6128 17.375L11.4003 18.875L12.0003 18.5375L12.6378 18.875L13.3878 17.375L12.3753 16.85C12.1503 16.7375 11.8503 16.7375 11.6253 16.85Z"
        fill="#111928"
      />
      <path d="M9.03737 18.1554L6.69482 19.3398L7.45622 20.8458L9.79877 19.6614L9.03737 18.1554Z" fill="currentColor" />
      <path
        d="M6.3 20.0754L6.0375 20.0379L5.8875 19.7754L5.5125 19.9629L4.6125 19.8129L4.425 20.9004C4.3875 21.2004 4.5 21.5379 4.7625 21.7254C4.9125 21.8379 5.1 21.8754 5.25 21.8754C5.4 21.8754 5.5125 21.8379 5.625 21.7629L6.6375 21.2379L6.1875 20.4129L6.3 20.0754Z"
        fill="currentColor"
      />
      <path d="M5.3907 15.5766L4.95898 18.0898L6.62218 18.3755L7.0539 15.8623L5.3907 15.5766Z" fill="currentColor" />
      <path
        d="M7.38779 13.9242C7.42529 13.6617 7.35029 13.3617 7.16279 13.1742L6.33779 12.3867L5.17529 13.5867L5.66279 14.0742L5.55029 14.7117L7.20029 15.0117L7.38779 13.9242Z"
        fill="currentColor"
      />
      <path d="M3.18057 9.39327L2.02295 10.6211L3.90561 12.3961L5.06324 11.1683L3.18057 9.39327Z" fill="currentColor" />
      <path
        d="M2.4001 9.3125L2.3626 9.0125L2.5501 8.825L2.2876 8.6L2.1376 7.625L0.975098 7.8125C0.637598 7.85 0.375098 8.075 0.300098 8.4125C0.225098 8.75 0.300098 9.05 0.525098 9.275L1.3876 10.025L1.9876 9.35L2.4001 9.3125Z"
        fill="currentColor"
      />
      <path d="M6.50305 6.9968L3.9043 7.36719L4.1424 9.03781L6.74115 8.66742L6.50305 6.9968Z" fill="currentColor" />
      <path
        d="M8.1002 6.79922L7.3877 6.87422L7.61269 8.56172L8.77519 8.41172C9.03769 8.37422 9.3002 8.22422 9.4127 7.96172L9.9377 6.98672L8.4377 6.19922L8.1002 6.79922Z"
        fill="#111928"
      />
      <path d="M10.3518 2.35742L9.17529 4.66211L10.6783 5.42942L11.8549 3.12473L10.3518 2.35742Z" fill="currentColor" />
    </svg>
  );
}
